import { render, staticRenderFns } from "./EventJournal.vue?vue&type=template&id=65b49f5a&scoped=true&"
import script from "./EventJournal.vue?vue&type=script&lang=js&"
export * from "./EventJournal.vue?vue&type=script&lang=js&"
import style0 from "./EventJournal.vue?vue&type=style&index=0&id=65b49f5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b49f5a",
  null
  
)

component.options.__file = "EventJournal.vue"
export default component.exports